import React from "react";
import { socialLinks } from '../../config/app';
import SocialLink from './SocialLink';

export default class FollowUs extends React.PureComponent {
    render() {
        return (
            <div className={'follow-us'}>
                <div className={'title'}>Follow Us</div>

                <div className={'icons'}>
                    {Object.keys(socialLinks).map((key, index) => {
                        return <SocialLink link={socialLinks[key]} icon={key} key={index}/>
                    })}
                </div>
            </div>
        );
    }
}

